import { makeApiRequestWithResponseType } from "./api.Interceptors";
import { AGENT_SPACE_API_SECRET_KEY, AGENT_SPACE_PROJECT_ID, service_acc_for_agentSpace, } from "@/constants";
import { createHmacSignature } from "@/shared/utils/helpers";
// current CW Space api calls
export const loginWithGoogle = async (scopes) => {
    return makeApiRequestWithResponseType("post", "/api/auth/google/addScopes", {
        data: { scopes: scopes },
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        baseURL: process.env.VITE_APPSEC_AUTH_BACKEND_URL,
        errorMessage: "Failed to fetch authorisation URL",
    });
};
export const getUserSession = async () => {
    return makeApiRequestWithResponseType("get", "/api/auth/session", {
        config: {
            withCredentials: true,
        },
        baseURL: process.env.VITE_APPSEC_AUTH_BACKEND_URL,
        errorMessage: "Failed to fetch session data",
    });
};
export const updateCWDatabase = async (userData) => {
    const requestData = {
        appsec_id: userData?._id || "string", // Replace "string" with a default value if necessary
        email: userData?.email || "user@example.com",
        user_name: userData?.provider?.name || "string",
        access_scopes: userData?.provider?.scope || "string",
        // persona: [],
    };
    return makeApiRequestWithResponseType("post", "/user/appsec/addUser", {
        data: requestData,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to update CW database",
    });
};
export const getCWUser = async (userEmail) => {
    return makeApiRequestWithResponseType("get", "/user/appsec/getUser", {
        params: { email: userEmail }, // Pass email as a query parameter
        config: {
            headers: {
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to get User, or User doesn't exist",
    });
};
export const listConversations = async (userEmail) => {
    return makeApiRequestWithResponseType("get", "/user/appsec/listConversations", {
        params: { email: userEmail }, // Pass email as a query parameter
        config: {
            headers: {
                Accept: "application/json",
            },
            timeout: 300000, // 5 min
        },
        errorMessage: "Failed to list conversations",
    });
};
export const listCWUsers = async () => {
    return makeApiRequestWithResponseType("put", "/user/appsec/listUser", {
        config: {
            headers: {
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to get User, or User doesn't exist",
    });
};
export const getCwUserPersona = async (userEmail) => {
    return makeApiRequestWithResponseType("get", "/user/appsec/getPersona", {
        params: { email: userEmail }, // Pass email as a query parameter
        config: {
            headers: {
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to get user persona, or this user doesn't exist",
    });
};
export const setCwUserPersona = async (userData) => {
    const requestData = userData;
    return makeApiRequestWithResponseType("put", "/user/appsec/setPersona", {
        data: requestData,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to update user's persona",
    });
};
export const setCwUserScopes = async (userData) => {
    const requestData = userData;
    return makeApiRequestWithResponseType("put", "/user/appsec/setAccessScopes", {
        data: requestData,
        config: {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        errorMessage: "Failed to update user's scopes",
    });
};
export const fetchModes = async () => {
    return makeApiRequestWithResponseType("get", "/modes", {
        errorMessage: "Failed to fetch modes",
    });
};
export const uploadFileToGCS = async (blob, projectId, filename, isAI) => {
    try {
        // Validate inputs
        if (!blob)
            throw new Error("No blob data provided");
        if (!projectId)
            throw new Error("No project ID provided");
        if (!filename)
            throw new Error("No filename provided");
        const blobType = blob.type || "application/octet-stream";
        const formData = new FormData();
        const file = new File([blob], filename, { type: blobType });
        console.log("file is ", file);
        formData.append("files", file);
        formData.append("project_id", projectId);
        formData.append("isAI", isAI.toString());
        return makeApiRequestWithResponseType("put", "/gcs/upload-files/", {
            data: formData,
            config: {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                maxContentLength: 500 * 1024 * 1024,
            },
            errorMessage: "Failed to upload file",
        });
    }
    catch (error) {
        return {
            responseData: null,
            error: {
                errorMessage: "Failed to upload file",
                errorObjData: error,
            },
        };
    }
};
export const uploadChatHistory = async (chatId, emailId, chatData) => {
    return makeApiRequestWithResponseType("post", `/proposals/chats?chat_id=${chatId}&email_id=${encodeURIComponent(emailId)}`, {
        data: {
            streaming_response: chatData,
        },
        errorMessage: "Failed to upload ChatHistory",
    });
};
export const updateChatHistory = async (chatId, chatData) => {
    return makeApiRequestWithResponseType("put", `/proposals/chats?chat_id=${chatId}`, {
        data: {
            streaming_response: chatData,
        },
        config: {
            timeout: 300000, // 5 min
        },
        errorMessage: "Failed to update ChatHistory",
    });
};
export const getChatHistory = async (chatId) => {
    return makeApiRequestWithResponseType("get", `/proposals/chats?chat_id=${chatId}`, {
        errorMessage: "Failed to get ChatHistory",
    });
};
export const fetchProjectById = async (projectId) => {
    return makeApiRequestWithResponseType("get", `/projects/${projectId}`);
};
export const uploadFilesToProject = async (projectId, projectLinks, userEmail, accessToken, refreshToken) => {
    const formData = new URLSearchParams({
        project_id: projectId,
        drive_links: JSON.stringify(projectLinks),
        user_email: userEmail,
        access_token: accessToken,
        refresh_token: refreshToken,
    }).toString();
    return makeApiRequestWithResponseType("post", "/gcs/upload-file-from-link/", {
        data: formData,
        config: {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            timeout: 900000, // 15 min
        },
        errorMessage: "Error adding files to project",
    });
};
export const createSubproject = async (parent_project_id, user, subproject_name, userName, subproject_description) => {
    return makeApiRequestWithResponseType("post", "/projects/subproject", {
        data: {
            parent_project_id: parent_project_id,
            user: user,
            subproject_name: subproject_name,
            subproject_description: subproject_description ?? "",
            user_name: userName
        },
        errorMessage: "Failed to create subproject",
    });
};
export const updateSubproject = async (projectId, params) => {
    return makeApiRequestWithResponseType("put", `/projects/${projectId}`, {
        data: params,
        errorMessage: "Failed to update project",
    });
};
export const fetchSubProjects = async (projectId) => {
    return makeApiRequestWithResponseType("get", `/projects/list_subprojects/${projectId}`, {
        errorMessage: "Failed to fetch sub projects info",
    });
};
export const fetchProjectHierarchy = async (projectId) => {
    return makeApiRequestWithResponseType("post", `/projects/get_project_hierarchy/${projectId}`, {
        errorMessage: "Failed to fetch project hierarchy",
    });
};
// not used anymore
export const updateUserChat = async (email, chatId) => {
    return makeApiRequestWithResponseType("put", `/user/chatUpdate/${email}?chatId=${chatId}`, {
        config: {
            timeout: 300000, // 5 min
        },
        errorMessage: "Failed to update user chat",
    });
};
export const addConversation = async (email, chatId, artifactId, projectId) => {
    const formData = new URLSearchParams();
    formData.append('email', email);
    formData.append('chat_id', chatId);
    formData.append('artifact_id', artifactId || ""); // Ensure empty string if null/undefined
    formData.append('project_id', projectId || ""); // Ensure empty string if null/undefined
    return makeApiRequestWithResponseType("put", "/user/appsec/addConversation", {
        data: formData.toString(),
        config: {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            timeout: 300000, // 5 min
        },
        errorMessage: "Failed to add conversation",
    });
};
export const updateFeedbackUpsert = async (feedbackPayloadData) => {
    return makeApiRequestWithResponseType("post", `/feedback/upsert_feedback`, {
        data: feedbackPayloadData,
        errorMessage: "Failed to update feedback",
    });
};
export const getSignedUrl = async (filePath, service_account_raw) => {
    const payload = {
        gsutil_url: `gs://${filePath}`,
        service_account_raw: service_account_raw,
    };
    return makeApiRequestWithResponseType("post", "/gcs/get-signed-url/", {
        data: payload,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to get signed URL",
    });
};
export const getFileContent = async (filePath) => {
    const formData = new URLSearchParams();
    formData.append("file_path", filePath);
    return makeApiRequestWithResponseType("post", "/gcs/get-file-content", {
        data: formData,
        config: {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        errorMessage: "Failed to get file content",
    });
};
export const retrieveFeedback = async (query, modeAssistantName) => {
    return makeApiRequestWithResponseType("get", "/feedback/retrieve_feedback", {
        params: {
            query: query?.trim() || "",
            db_index: `${modeAssistantName}-agentGuide`,
        },
        errorMessage: "Failed to fetch feedback",
    });
};
export const getUserData = async (userEmail) => {
    return makeApiRequestWithResponseType("get", `/user/${userEmail}`, {
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to fetch user data",
    });
};
// not used any more
export const getUserPersonna = async (email) => {
    const formData = new FormData();
    formData.append("email", email || "");
    return makeApiRequestWithResponseType("post", "/user/getPersonna", {
        data: formData,
        config: {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        },
        errorMessage: "Failed to fetch user persona",
    });
};
// not used any more
export const setUserPersonna = async (email, selectedPersonas) => {
    const personasData = {
        personna: selectedPersonas,
        email: email || "",
    };
    return makeApiRequestWithResponseType("post", "/user/setPersonna", {
        data: personasData,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to update user persona",
    });
};
// not used any more
export const setUserAccessScopes = async (email, selectedScopes) => {
    const params = new URLSearchParams({
        email: email || "",
        scopes: selectedScopes.join(","),
    });
    return makeApiRequestWithResponseType("post", "/user/setAccessScopes", {
        data: params.toString(),
        config: {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to update user access scopes",
    });
};
// not used any more
export const listUsers = async () => {
    return makeApiRequestWithResponseType("get", "/user/listUser", {
        errorMessage: "Failed to fetch users list",
    });
};
// not used any more
export const updateUserTokens = async (email, accessToken, refreshToken) => {
    // Determine if we should send tokens in the body
    const data = accessToken && refreshToken
        ? { access_token: accessToken, refresh_token: refreshToken }
        : null;
    return makeApiRequestWithResponseType("put", `/user/${encodeURIComponent(email)}/update-tokens`, {
        // data: {
        //   access_token: accessToken,
        //   refresh_token: refreshToken,
        // },
        data: data,
        config: {
            headers: {
                "Content-Type": data ? "application/json" : undefined,
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to update user tokens",
    });
};
// not used any more
export const addUser = async (userData) => {
    return makeApiRequestWithResponseType("post", "/user/addUser", {
        data: userData,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to add user",
    });
};
export const createMode = async (data) => {
    const formData = new URLSearchParams();
    formData.append("modeName", data.modeName);
    formData.append("url", data.url);
    formData.append("modeDescription", data.modeDescription);
    formData.append("module", data.module);
    formData.append("remote", data.remote);
    formData.append("modeId", data.modeId);
    return makeApiRequestWithResponseType("post", "/modes", {
        data: formData.toString(),
        config: {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        errorMessage: "Failed to create mode",
    });
};
export const getProjects = async () => {
    return makeApiRequestWithResponseType("get", "/projects", {
        errorMessage: "Failed to get projects",
    });
};
export const createProject = async (userData, projectName, projectDescription, userName) => {
    return makeApiRequestWithResponseType("post", "/projects", {
        data: {
            user: userData,
            name: projectName,
            description: projectDescription,
            user_name: userName,
        },
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to create project",
    });
};
export const manualUploadFilesToGCS = async (projectId, files, isAI = false) => {
    const formData = new FormData();
    formData.append("project_id", projectId);
    // Append each file to the formData
    Array.from(files).forEach((file) => {
        formData.append("files", file);
    });
    formData.append("isAI", isAI.toString());
    return makeApiRequestWithResponseType("put", "/gcs/upload-files/", {
        data: formData,
        config: {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            timeout: 900000, // only for this api request to be 15 minutes.
        },
        errorMessage: "Failed to upload files",
    });
};
export const renameFile = async (projectId, currentFileName, newFileName) => {
    return makeApiRequestWithResponseType("put", "/gcs/rename-file/", {
        data: {
            project_id: projectId,
            current_filename: currentFileName,
            new_filename: newFileName,
        },
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to rename file",
    });
};
export const getModeById = async (modeId) => {
    return makeApiRequestWithResponseType("get", `/modes/${modeId}`, {
        errorMessage: "Failed to fetch mode data",
    });
};
export const updateMode = async (modeId, payload) => {
    return makeApiRequestWithResponseType("put", `/modes/${modeId}`, {
        data: payload,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to update mode",
    });
};
export const fetchKeywords = async () => {
    return makeApiRequestWithResponseType("get", "/settings/keywords", {
        errorMessage: "Failed to fetch keywords",
    });
};
export const updateKeywords = async (id, keywords) => {
    return makeApiRequestWithResponseType("put", `/settings/keywords/${id}`, {
        data: { keywords },
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to update keywords",
    });
};
export const downloadFileFromGCS = async (filePath, service_account_raw) => {
    const payload = {
        gsutil_url: `gs://${filePath}`,
        service_account_raw: service_account_raw,
    };
    return makeApiRequestWithResponseType("post", `gcs/download-file/`, {
        data: payload,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
            timeout: 3000000, // only for this api request to be 5 minutes.
            responseType: "blob",
        },
        errorMessage: "Failed to download file",
    });
};
export const postEmailNotify = async (emailNotifyPayload) => {
    return makeApiRequestWithResponseType("post", "/process/track_request", {
        data: emailNotifyPayload,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to send email",
    });
};
export const transcriptChunks = async (audioBlob, filename) => {
    const formData = new FormData();
    formData.append("resource", audioBlob, filename);
    return makeApiRequestWithResponseType("post", "/media", {
        data: formData,
        config: {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        },
        baseURL: "https://transcription-service-backend-693246358019.us-central1.run.app",
        errorMessage: "Failed to transcript chunks",
    });
};
export const grantViewerAccess = async (email) => {
    const requestData = {
        project_id: AGENT_SPACE_PROJECT_ID,
        member_email: email,
        service_account: service_acc_for_agentSpace,
        timestamp: new Date().toISOString(),
    };
    // Serialize to JSON for signature
    const jsonData = JSON.stringify(requestData);
    // Create HMAC signature
    const signature = createHmacSignature(AGENT_SPACE_API_SECRET_KEY, jsonData);
    return makeApiRequestWithResponseType("post", "/agentspace/grant_viewer_access", {
        config: {
            headers: {
                "X-API-Signature": signature,
            },
        },
        data: requestData,
        errorMessage: "Failed to grant viewer access",
    });
};
export const checkUserInAgentSpace = async (email) => {
    return makeApiRequestWithResponseType("get", "/agentspace/is_user_added_to_agentspace", {
        params: {
            user_id: email,
            project_id: AGENT_SPACE_PROJECT_ID,
        },
        config: {
            headers: {
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to check user access",
    });
};
export const validateUserWithProject = async (userEmail, projectId) => {
    return makeApiRequestWithResponseType("get", "/projects/validate_user", {
        params: {
            user_email: userEmail,
            project_id: projectId,
        },
        config: {
            headers: {
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to validate user access",
    });
};
export const listProjectsByUser = async (userEmail) => {
    return makeApiRequestWithResponseType("get", "/projects/list_projects_by_user", {
        params: {
            user_email: userEmail,
        },
        config: {
            headers: {
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to list projects for user",
    });
};
export const listUsersByProject = async (projectId) => {
    return makeApiRequestWithResponseType("get", "/projects/list_users_by_project", {
        params: {
            project_id: projectId,
        },
        config: {
            headers: {
                Accept: "application/json",
            },
        },
        errorMessage: "Failed to list users for project",
    });
};
export const updateAccess = async (projectId, updates) => {
    return makeApiRequestWithResponseType("put", "/projects/update_access", {
        data: {
            project_id: projectId,
            updates: updates,
        },
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to update access",
    });
};
export const sendEmailToOwner = async (fromEmail, toEmail, body, subject, accessToken, refreshToken) => {
    const emailData = {
        from_email: fromEmail,
        to_email: toEmail,
        subject: subject,
        body: body,
        access_token: accessToken,
        refresh_token: refreshToken
    };
    return makeApiRequestWithResponseType("post", `/utility/email`, {
        data: emailData,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to send email to user",
    });
};
export const deleteFile = async (projectId, fileUrl) => {
    const deleteFilePayload = {
        project_id: projectId,
        file_url: fileUrl
    };
    return makeApiRequestWithResponseType("delete", `/gcs/delete-file`, {
        data: deleteFilePayload,
        config: {
            headers: {
                "Content-Type": "application/json",
            },
        },
        errorMessage: "Failed to delete file",
    });
};
